import { render, staticRenderFns } from "./output-model.vue?vue&type=template&id=187095d8&scoped=true"
import script from "./output-model.vue?vue&type=script&lang=js"
export * from "./output-model.vue?vue&type=script&lang=js"
import style0 from "./output-model.vue?vue&type=style&index=0&id=187095d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187095d8",
  null
  
)

export default component.exports